import { Component, OnInit } from "@angular/core";
import { ComponentBase } from "../../models/ComponentBase";
import { LoginService } from "../../services/login.service";
import { GetESGChartResponse, GetESGMatrixResponse, UserRight } from "../../WebApiClient";
import { ESGService } from "../../services/esg.service";

@Component({
    selector: "app-sustainability",
    templateUrl: "./sustainability.component.html",
    styleUrls: [
        "./sustainability.component.scss",
        "../../style/sidebarLayout.scss",
    ],
    standalone: false
})
export class SustainabilityComponent extends ComponentBase implements OnInit {
    public showProjectCo2Consumption: boolean = false;
    public esgMatrixData: GetESGMatrixResponse | undefined;
    public esgChartData: GetESGChartResponse | undefined;

    constructor(private readonly loginService: LoginService, private readonly esgService: ESGService) {
        super();

        this.showProjectCo2Consumption = this.loginService.hasRights(
            UserRight.EditSustainability
        );
    }

    ngOnInit(): void {
        this.esgService.getMatrix().then((data) => {
            this.esgMatrixData = data;
        });
        this.esgService.getChartData().then((data) => {
            this.esgChartData = data;
        });
    }
}




